import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren, useState } from 'react'
import { CreditUnionIcon, IconCodeType } from '../icon/CreditUnionIcon'
import { QuickLinksItem } from './QuickLinksItem'
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary } from './styledAccordionCard'
import {
  StyledCardContainer,
  StyledCardList,
  StyledChevronGridWrapper,
  StyledTitleCheveron,
  StyledTitleGridWrapper,
  StyledTitleText,
} from './styledQuickLinksCard'

export type QuickLinksAccordianCardProps =  Omit<React.ComponentProps<typeof StyledCardContainer>, 'variant'> & {
  title: string
  iconCode: IconCodeType
  href?: string | undefined
  target?: string | undefined
}


export const QuickLinksAccordianCard: React.FC<PropsWithChildren<QuickLinksAccordianCardProps>> =  ({ title, iconCode, href, children, variant, ...props }) => {
  const [cheveronRotate, setCheveronRotate] = useState(false)
  const handleAccordionChange = () => {
    setCheveronRotate(!cheveronRotate)
  }

  return (
    <StyledCardContainer item xs={12} sm={12} {...props}>
      <StyledAccordion onChange={handleAccordionChange}>
        <StyledAccordionSummary>
          <Grid container spacing={1} alignItems="center" justifyContent="space-between" wrap="nowrap">
            <Grid item>
              <Grid container direction="row" justifyContent="flex-start" alignItems="center" wrap="nowrap">
                <Grid item>
                  <CreditUnionIcon width={33} height={33} iconCode={iconCode}/>
                </Grid>
                <StyledTitleGridWrapper item>
                  <StyledTitleText>{title}</StyledTitleText>
                </StyledTitleGridWrapper>
              </Grid>
            </Grid>
            <StyledChevronGridWrapper item>
              <StyledTitleCheveron $rotate={cheveronRotate} icon={faChevronDown}/>
            </StyledChevronGridWrapper>
          </Grid>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <StyledCardList>
            <QuickLinksItem href={href || '#'}>
              Overview
            </QuickLinksItem>
            { children }
          </StyledCardList>
        </StyledAccordionDetails>
      </StyledAccordion>
    </StyledCardContainer>
  )
}